import { TextInput } from "components/FormInputs/TextInput";

interface CompanyContactInfoProps {
	onFieldChanged?: (e: React.ChangeEvent<any>) => void;
}

export const CompanyContactInfo: React.FC<CompanyContactInfoProps> = ({
	onFieldChanged,
}) => {
	return (
		<>
			{
				//@ts-ignore
				<TextInput
					label="Primary Contact Name"
					data-testid="company-primary-contact-name"
					required="true"
					name="contactName"
					type="text"
					guideLine="This is the main point of contact for your account and profile."
					onChange={onFieldChanged}
				/>
			}
			{
				//@ts-ignore
				<TextInput
					label="Company Phone Number"
					testId="company-phone-number"
					required="true"
					name="phone"
					type="text"
					flexGrow="1"
					onChange={onFieldChanged}
				/>
			}
			{
				// @ts-ignore
				<TextInput
					label="Company Email Address"
					testId="company-email"
					required="true"
					name="email"
					type="text"
					guideLine={
						"Primary email address to be used as main contact on procuracon"
					}
					onChange={onFieldChanged}
				/>
			}
		</>
	);
};
